import React, { Component } from 'react'
import { connect } from 'react-redux';

import classnames from "classnames";
import Button from './../shared/Button/index';

import styles from './../../styles/perfect_essay.styl';
import baseStyles from 'custom/base.styl';
import success from './../../img/success@3x.png';

import { profileUpdateStages } from "../../store/profile/actions";

class EssayHealthcare extends Component {
  constructor(props) {
    super(props)

    this.state = {
      curStep: 'step1',
    }

    this.onStepClick = this.onStepClick.bind(this)
    this.onComplete = this.onComplete.bind(this)
    this.onStageNext = this.onStageNext.bind(this)
  }

  onStepClick(e) {
    const newStep = e.target.dataset.step;

    this.setState({
      curStep: newStep,
    });

    const el = document.getElementById(newStep);
    el.scrollIntoView({ behavior: "smooth" });

    // this.setState({
    //   curStep: newStep,
    // }, () => window.scrollTo({ top: offsetTop, behavior: 'smooth' }));
  }

  onComplete() {
    this.setState({
      curStep: 'finish',
    }, () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  onStageNext() {
    const { nextStage } = this.props;
    nextStage();
    return;
  }

  render() {
    const { curStep } = this.state;

    return (
      <div>
        {/* page-1 */}
        <div className={classnames(styles.perfect_essay)}>

          <div className={classnames(styles.comment_finish, { [styles.active]: curStep === 'finish' })}>
            <img src={success} alt="success" width="100px" />
            <h3>Thank you for completing <br /> the first essay</h3>
						<p>There’s only one test essay left <br /> before you join us as a writer and <br /> start working with real orders. <br /> Show there all your academic <br /> knowledge and writing skills, as we <br /> will check it thoroughly to decide <br /> whether you have passed the <br /> probation.</p>
            <Button onClick={(e) => this.onStageNext(e)} block >Begin the last essay</Button>
          </div>

          <div className={styles.catchword_left}>Running head: IMPACT OF NURSES ON HEALTH IT</div>
          <div className={styles.catchword}>1</div>

          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />

          <div className={classnames(styles.highlighting, styles.highlighting_type1, { [styles.active]: curStep === 'step1' })} data-step="step1" id="step1">

            <div className={styles.highlighting_content}>

              <div className={styles.center}>Impact of Nurses on Health IT</div>
              <div className={styles.center}>Name of Student</div>
              <div className={styles.center}>Institution Affiliation</div>

              <div className={classnames(styles.comment)}>
                <ul>
                  <li>The paper follows the requirements of the APA formatting style.</li>
                  <li>No personal information is included.</li>
                  <li>Please download a template to avoid mistakes and spend less time on formatting. </li>
                </ul>
                <div className={classnames(styles.btn_wrap, baseStyles.flex_right)}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step2">NEXT&rarr;&nbsp;</button>
                </div>
              </div>

            </div>
          </div>

        </div>

        {/* page-2 */}
        <div className={classnames(styles.perfect_essay)}>
          <div className={styles.catchword_left}>Running head: IMPACT OF NURSES ON HEALTH IT</div>
          <div className={styles.catchword}>2</div>

          <div className={classnames(styles.highlighting, styles.highlighting_type2, { [styles.active]: curStep === 'step2' })} data-step="step2" id="step2">
            <div className={styles.highlighting_content}>
              <div className={styles.center}>Role of Nurses in Healthcare System</div>
              <p>Nurses are responsible for a large number of critical things such as reducing the frequency of medical errors, to promoting wellbeing and creating a balance between efficiency and reduced cost. </p>

              <div className={styles.comment}>
                <ul>
                  <li>The instructions are followed: the paper answers the required task “discuss the role of nurses in healthcare system” explicitly. </li>
                  <li>Structure: The introduction contains an arguable thesis statement.</li>
                  <li>The word count of the introduction is 10%.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step1">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step3">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type3, { [styles.active]: curStep === 'step3' })} data-step="step3" id="step3">
            <div className={styles.highlighting_content}>
              <p>Nurses play potentially the most critical role within the healthcare system. They are the ones who work one on one with the patients themselves and are the ones who are in charge of overseeing the quality and efficiency of the care provided. Nursing is considered one of the most honest and ethical jobs by the adult population in the US. Nurses are generally trusted with health-related information and care. However, nurses themselves have little impact on the healthcare reform, including when it comes to implementing health IT systems (Joy et al., 2010). Regardless of them being able to execute proper medical judgment and show leadership, they are still not heard when they speak up about making changes to the way the healthcare systems are processed, although, by all means, serve as the foundation on which the healthcare system is based.</p>
              <div className={styles.comment}>
                <ul>
                  <li>Content: The paragraph discusses one idea that is a part of the thesis statement.</li>
                  <li>Structure: The paragraph begins with a topic sentence that explains the main idea. It is followed by the analysis supported with outside information cited in APA. </li>
                  <li>Language: No personal pronouns, phrasal verbs, contractions, idioms, colloquial language, rhetorical questions are used.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step2">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step4">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type4, { [styles.active]: curStep === 'step4' })} data-step="step4" id="step4">
            <div className={styles.highlighting_content}>
              <p>Workarounds are defined as controversial or unfavorable methods taken to temporarily adjust or fix a workflow problem which is preventing some set goal. These types of behaviors include improvisation, deviation, shortcuts, rushed problem-solving, violations, and sometimes even failures in certain procedures (Debono et al., 2013). These types of situations can lead to a worse condition, however, in many cases they are the only way to navigate and respond to a complicated patient care delivery. The situation can be improved by increasing the number of nurses working on one floor and thus sharing their responsibilities. </p>
              <div className={styles.comment}>
                <ul>
                  <li>Content: The paragraph answers the required question “Discuss the impact of the workaround or workflow issue” explicitly.</li>
                  <li>Word count of the body paragraphs comprise 80% (240 words).</li>
                  <li>Proofreading: No repetitions, misprints, punctuation issues are present in the paper.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step3">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step5">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type1, { [styles.active]: curStep === 'step5' })} data-step="step5" id="step5">
            <div className={styles.highlighting_content}>
              <p>To alleviate such damaging behavior, more nurses should work on one floor. This will divide the work and attention between more professionals and lessen the necessity to bend the rules in order to meet the goals. </p>
              <div className={classnames(styles.comment, styles.comment_bottom)}>
                <ul>
                  <li>Content: The Conclusion contains no new information and restates the thesis. </li>
                  <li>Structure: The word count of the Conclusion is 10% of the required word count (1 page = 300 words). </li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step4">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step6">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>
        </div>


        {/* page-3 */}
        <div className={classnames(styles.perfect_essay)}>
          <div className={styles.catchword_left}>Running head: IMPACT OF NURSES ON HEALTH IT</div>
          <div className={styles.catchword}>3</div>

          <div className={classnames(styles.highlighting, styles.highlighting_type3, { [styles.active]: curStep === 'step6' })} data-step="step6" id="step6">
            <div className={styles.highlighting_content}>
              <div className={styles.center}>References</div>

              <div>Debono, D., Greenfield, D., Travaglia, J., Long, J., Black, D., Johnson, J., & Braithwaite, J. </div>
              <p>(2013). Nurses’ workarounds in acute healthcare settings: a scoping review. <i>BMC </i></p>
              <p><i>Health Services Research, 13</i>(1).<a href="http://dx.doi.org/10.1186/1472-6963-13-175">http://dx.doi.org/10.1186/1472-6963-13-175</a></p>

              <div>Joy, T., Blue, L., Fecher, A., Gomez, G., Simons, C., & Kemp, H. (2010). Nurses Should</div>
              <p>Have More Influence on Health Systems and Services. <i>JONA: The Journal Of </i></p>
              <p><i>Nursing Administration, 40</i> (4), 181. </p>
              <p><a href="http://dx.doi.org/10.1097/01.nna.0000323973.98156.ea">http://dx.doi.org/10.1097/01.nna.0000323973.98156.ea</a></p>


              <div className={classnames(styles.comment)}>
                <ul>
                  <li>The minimum requirement to include 1 source per 1 page (300 words) is met.</li>
                  <li>The incorporated sources are reliable, relevant (published within the last 5-7 years), and to the topic.</li>
                  <li>Works Cited page is formatted according to the requirements of the APA formatting style. </li>
                  <li>The list of sources is alphabetized.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step5">&larr;&nbsp;PREVIOUS</button>
                  <Button onClick={(e) => this.onComplete(e)} className={styles.btn_finish} light>Finish</Button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  nextStage: () => dispatch(profileUpdateStages()),
});

export default connect(null, mapDispatchToProps)(EssayHealthcare);




// WEBPACK FOOTER //
// ./src/components/PerfectEssay/EssayHealthcare.js